// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"2785633a","551":"8a1244f7","781":"9d16b210"}[chunkId] + ".chunk.js";
};